import { Attestation, JSONFormData } from '~/types';
import { Context } from './types';

export const formDataToAttestation = (
  formData: JSONFormData,
  context: Context
): Omit<Attestation, 'dateSubmitted' | 'signatureMethod' | 'id'> & { id?: number } => {
  // Clear details when question value is false
  const cleanedFormData = { ...formData };

  Object.keys(cleanedFormData).forEach((key) => {
    const section = cleanedFormData[key];
    if (section && typeof section === 'object' && 'question' in section && 'details' in section) {
      if (section.question?.value === 'No') {
        section.details = undefined;
      }
    }
  });

  const attestation = {
    id: context.idToEdit || undefined,
    attestationType: 'Attestation', // where do we get this?
    formInstance: {
      formType: 'attestation',
      formData,
      jsonFormId: context.jsonFormId, // Get from context
    },
    attestationFormId: context.attestationFormId, // get from Context,
    providerId: context.providerId, // get from context
  };

  return attestation;
};
